export const stringifyTime = (time: number): string => {
  return time.toString().replace(/(.{2})$/, ':$1');
};
